<template>
    <form @change="update">
        <input id="title" type="text" placeholder="Name" v-model="title"/>

        <textarea placeholder="Description" v-model="body"></textarea>
    </form>
</template>

<script>
    import Button from './Button';

    export default {
        data() {
            return {
                title: undefined,
                body: undefined
            };
        },
        methods: {
            update(e) {
                this.$emit('change', {
                    title: this.title,
                    body: this.body
                });
            }
        },
        components: {
            Button
        }
    }
</script>

<style scoped lang="scss">
    form {
        input {
            width: 100%;
            margin-bottom: $space-32;
        }
        textarea {
            width: 100%;
            resize: none;
            height: $space-256;
        }
    }
</style>